// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Bsu5","modalForm":"UpgradeEpcsModal_modalForm__1_BJU","modalFooter":"UpgradeEpcsModal_modalFooter__5CtMQ"};